import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useTransition, config, animated } from 'react-spring';
import { StyledLink, Container, Thumbnail, StyledResponsiveImage, Content, Title, Description } from './Tutorial.styles.js';
import '../../hooks/index.js';
import { useTrackEventInView } from '../../hooks/useTrackEventInView.js';
import { useTrackEvent } from '../../hooks/useTrackEvent.js';

/**
 *
 * Guide
 *
 * This components renders the items for the Guide section
 * in the Discover page.
 */
const Guide = ({ id, featured, title, content, image, url, }) => {
    // Analytics
    const { ref } = useTrackEventInView(featured ? 'DISCOVER - G - Article Featured' : 'DISCOVER - G - Article', {
        type: 'load',
        target: title,
    });
    const { trackEvent } = useTrackEvent();
    const transitions = useTransition(id, null, {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: config.slow,
    });
    return (jsx(Fragment, { children: transitions.map(({ item, key, props }) => item && (jsx(animated.div, Object.assign({ style: props }, { children: jsx(StyledLink, Object.assign({ target: "_blank", href: url, external: true, onClick: () => {
                    trackEvent(featured
                        ? 'DISCOVER - G - Article Featured'
                        : 'DISCOVER - G - Article', {
                        target: title,
                        type: 'click',
                    });
                } }, { children: jsxs(Container, Object.assign({ featured: featured, ref: ref }, { children: [jsx(Thumbnail, Object.assign({ featured: featured }, { children: jsx(StyledResponsiveImage, { image: image, withSkeletonUI: true }) })), jsxs(Content, Object.assign({ featured: !!featured }, { children: [jsx(Title, Object.assign({ featured: !!featured }, { children: featured ? 'Featured' : title })), jsx(Description, Object.assign({ featured: !!featured }, { children: featured ? title : content }))] }))] })) })) }), key))) }));
};

export { Guide as default };
